import { render, staticRenderFns } from "./AdministrationPage.vue?vue&type=template&id=1501e873&"
import script from "./AdministrationPage.vue?vue&type=script&lang=js&"
export * from "./AdministrationPage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/adminSection.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./AdministrationPage.vue?vue&type=style&index=1&id=1501e873&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports